<template>
  <section class="mt-4">
    <h1 class="text-gray-500 text-md mb-2">
      Change the background color of the narrative. The transition duration
      specifies how quickly the background changes while scrolling.
    </h1>

    <div class="block">
      <label
        for="transition-duration"
        class="block text-sm leading-5 font-medium text-gray-700 mb-2 mt-4"
        >Transition duration (in pixels)</label
      >
      <v-select
        v-model="element.duration"
        :options="transitionDuration"
        class="mb-4"
      ></v-select>
    </div>

    <color-form :element='element' mode='backgroundOnly'></color-form>

  </section>
</template>

<script>
// import Component from "../component_location"
import VSwatches from "vue-swatches";
import ColorForm from "@/components/ElementForm/ColorForm.vue";

export default {
  components: { VSwatches, ColorForm },

  props: ["element"],

  data() {
    return {
      transitionDuration: [100, 200, 300, 400, 500, 600, 700, 800],
    };
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {
    if (this.element.duration == 0) {
      this.element.duration = 100;
    }
  },
};
</script>

<style></style>
